var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "pdfTemple",
      staticStyle: {
        color: "#000",
        "font-size": "24px",
        "line-height": "36px",
        position: "absolute",
        bottom: "-9999px",
        width: "1920px",
        padding: "30px",
      },
    },
    [
      _c("div", { staticStyle: { padding: "50px" } }, [
        _c(
          "div",
          {
            staticClass: "flex-align flex-spacebetween",
            staticStyle: { "margin-bottom": "40px" },
          },
          [
            _c("img", {
              staticStyle: { width: "140px", height: "60px" },
              attrs: {
                src: "https://minio.wooper.com/test/11/1724383663894_16WJDALX.png",
              },
            }),
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: {
                  width: "56%",
                  padding: "0px 60px 10px",
                  "border-bottom": "1px solid #000",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "44px",
                      "margin-right": "60px",
                    },
                  },
                  [_vm._v("DELIVERY NOTE")]
                ),
                _c("span", [_vm._v(_vm._s(_vm.customer.innerOrderNo))]),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticStyle: { width: "50%", "padding-left": "10px" } }, [
            _c("div", { staticStyle: { "font-size": "32px" } }, [
              _vm._v("DODGE INDUSTRIAL AUSTRALIA"),
            ]),
            _c("div", { staticStyle: { "font-size": "32px" } }, [
              _vm._v("PTY LTD"),
            ]),
            _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
              _vm._v("ABN 30 653 869 204"),
            ]),
            _c("div", { staticClass: "title" }, [_vm._v("Bill To/Payer")]),
            _c("div", [_vm._v(_vm._s(_vm.customer.receiverName))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.deliveryAddress1))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.city))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.district))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.country))]),
            _c("div", { staticClass: "title" }, [_vm._v("Sold To")]),
            _c("div", [_vm._v(_vm._s(_vm.customer.receiverName))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.deliveryAddress1))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.city))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.district))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.country))]),
            _c("div", { staticClass: "title" }, [_vm._v("Ship To")]),
            _c("div", [_vm._v(_vm._s(_vm.customer.receiverName))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.deliveryAddress1))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.city))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.district))]),
            _c("div", [_vm._v(_vm._s(_vm.customer.country))]),
          ]),
          _c("div", { staticStyle: { width: "50%" } }, [
            _c("div", { staticClass: "flex-align" }, [
              _c("div", { staticStyle: { width: "70%" } }, [
                _vm._v("Delivery Note No"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.customer.innerOrderNo))]),
            ]),
            _c("div", { staticClass: "flex-align" }, [
              _c("div", { staticStyle: { width: "70%" } }, [
                _vm._v("Despatch Date"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.customer.hjShipmentTime))]),
            ]),
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _c(
              "div",
              {
                staticStyle: {
                  border: "1px solid #000",
                  "margin-top": "20px",
                  padding: "1px",
                },
              },
              [
                _c("div", { staticClass: "flex-align" }, [
                  _c("div", { staticStyle: { width: "70%" } }, [
                    _vm._v("Customer PO"),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.customer.lineOrderCustomerRef)),
                  ]),
                ]),
                _c("div", [_vm._v("Customer Contact")]),
                _c("div", [_vm._v("Customer Reference")]),
              ]
            ),
            _c("div", { staticClass: "flex-align" }, [
              _c("div", { staticStyle: { width: "70%" } }, [
                _vm._v("Sales Order Number"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.customer.outerOrderNo))]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticStyle: { padding: "0 40px", "margin-top": "16px" } },
        [
          _vm._m(4),
          _vm._m(5),
          _vm._l(_vm.tableList, function (item, index) {
            return _c("div", { key: index, staticClass: "flex-align" }, [
              _c("div", { staticStyle: { width: "35%" } }, [
                _vm._v(_vm._s(item.skuCode)),
                _c("br"),
                _vm._v(_vm._s(item.skuName)),
              ]),
              _c("div", { staticStyle: { width: "15%" } }, [
                _vm._v(_vm._s(item.quantity)),
              ]),
              _c("div", { staticStyle: { width: "10%" } }, [
                _vm._v(_vm._s(item.weight)),
              ]),
              _c("div", { staticStyle: { width: "10%" } }, [_vm._v("ea kg")]),
              _c("div", { staticStyle: { width: "10%" } }, [_vm._v("0")]),
              _c("div", { staticStyle: { width: "10%" } }, [
                _vm._v(_vm._s(item.quantity)),
              ]),
              _c("div", { staticStyle: { width: "10%" } }, [_vm._v("0")]),
            ])
          }),
          _c(
            "div",
            {
              staticStyle: {
                height: "100px",
                "border-top": "1px solid #000",
                "border-bottom": "1px solid #000",
                "margin-top": "400px",
              },
            },
            [
              _c("div"),
              _c("div", [
                _vm._v(
                  "Total Weight(KG) - " + _vm._s(_vm.customer.totalWeight)
                ),
              ]),
            ]
          ),
          _vm._m(6),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-align" }, [
      _c("div", { staticStyle: { width: "70%" } }, [_vm._v("Plant")]),
      _c("div", [_vm._v("AUZP")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-align" }, [
      _c("div", { staticStyle: { width: "70%" } }, [_vm._v("Shipping Point")]),
      _c("div", [_vm._v("CSG")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-align" }, [
      _c("div", { staticStyle: { width: "70%" } }, [
        _vm._v("Terms of Delivery"),
      ]),
      _c("div", [_vm._v("EXW NAME OF CITY")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-align" }, [
      _c("div", { staticStyle: { width: "70%" } }, [
        _vm._v("Manner of transport"),
      ]),
      _c("div", [_vm._v("ROAD")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "border-top": "1px solid #000",
          padding: "20px 10px 0",
          "border-bottom": "1px solid #000",
        },
      },
      [
        _c("div", { staticStyle: { "line-height": "1" } }, [
          _vm._v("CONDITIONS OF SALE"),
        ]),
        _c("div", [
          _vm._v(
            "Unless DODGE expressly acknowledges in writing that DODGE's General Terms and Conditions of Sale have been replaced"
          ),
        ]),
        _c("div", [
          _vm._v(
            "by other agreed terms and conditions, this Sales Order Acknowledgement is issued pursuant to DODGE's General Terms and"
          ),
        ]),
        _c("div", [
          _vm._v(
            "Conditions of Sale which are located at https://dodgeindustrial.com/terms-conditions-usa/ or are attached to this Sales Order"
          ),
        ]),
        _c("div", [
          _vm._v(
            "Acknowledgement.These General Terms and Conditions of Sale prevail over, and apply notwithstanding,any wording in any"
          ),
        ]),
        _c("div", [
          _vm._v(
            "order or other communication seeking to impose the use of alternative terms and conditions."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "flex-align",
        staticStyle: {
          "border-bottom": "1px solid #000",
          "margin-bottom": "10px",
        },
      },
      [
        _c("div", { staticStyle: { width: "10%" } }, [_vm._v("Item")]),
        _c("div", { staticStyle: { width: "25%" } }, [
          _vm._v("Part Number | Serial Number"),
          _c("br"),
          _vm._v("Manufacturer Part Number"),
          _c("br"),
          _vm._v("Part Number Customer | Description"),
        ]),
        _c("div", { staticStyle: { width: "15%" } }, [_vm._v("Quantity")]),
        _c("div", { staticStyle: { width: "10%" } }, [_vm._v("Weight")]),
        _c("div", { staticStyle: { width: "10%" } }, [_vm._v("Unit")]),
        _c("div", { staticStyle: { width: "10%" } }, [
          _vm._v("Previous shipped qty"),
        ]),
        _c("div", { staticStyle: { width: "10%" } }, [
          _vm._v("Quantity Shipped"),
        ]),
        _c("div", { staticStyle: { width: "10%" } }, [_vm._v("Back Ordered")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "flex-align flex-spacebetween" }, [
        _c("div", [_vm._v("Postal Address :")]),
        _c("div", [_vm._v("Website : www.dodgeindustrial.com")]),
      ]),
      _c("div", [_vm._v("DODGE INDUSTRIAL AUSTRALIA PTY LTD")]),
      _c("div", { staticClass: "flex-align flex-spacebetween" }, [
        _c("div", [_vm._v("L61, 1 Farrer Place")]),
      ]),
      _c("div", [_vm._v("Sydney 2000 NSW")]),
      _c("div", [_vm._v("Australia")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }